import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { seleccionarPagina } from "../../../features/ui/uiSlice";
import { ValidacionComponent } from "../../../components/ValidacionComponent";
import { useForm } from "../../../hooks/useForm";
import { RootState } from "../../../store";
import { Label } from "../../../components/ui/Label";
import { Input } from "../../../components/ui/Input";
import Button from "../../../components/ui/Button";
import {
  useAgregarSiniestroMutation,
  useLazyVerPolizaQuery,
  useValidacionQuery,
} from "../../../services/docs";
import { toastr } from "react-redux-toastr";

export const SiniestroScreen = () => {
  const dispatch = useDispatch();
  const [validacion, setValidacion] = useState(false);
  const { seleccion } = useSelector((state: RootState) => state.ui);
  const [siniestroAction, { isLoading }] = useAgregarSiniestroMutation();
  const { data } = useValidacionQuery(seleccion);
  const [verAction] = useLazyVerPolizaQuery();

  const {
    formulario,
    handleInputChange,
    handleSelectChange,
    handleChangeAll,
    handleTexareChange,
    limpiarFormulario,
  } = useForm({
    fc_descripcion: "",
    fi_tipo_siniestro: "",
    fc_fecha_siniestro: "",
    fc_parentesco: "",
    fc_nombre_quien: "",
    fc_telefono_reporta: "",
    fc_estimada: "",
    fc_calle: "",
    fc_num_int: "",
    fc_num_ext: "",
    fc_colonia: "",
    fc_cp: "",
    fc_delegacion: "",
    fc_estado: "",
    fc_ciudad: "",
    fc_email: "",
    fc_observaciones: "",
    fc_marca: "",
    fc_modelo: "",
    fc_id: seleccion,
  });

  const agregarSiniestro = async () => {
    if (+formulario.fi_tipo_siniestro === 0) {
      toastr.error("Debe Llenar el tipo de Siniestro");
      return;
    }
    if (+formulario.fi_tipo_siniestro === 0) {
      toastr.error("Debe Llenar el tipo de Siniestro");
      return;
    }
    if (formulario.fc_fecha_siniestro === "") {
      toastr.error("Debe Llenar La fecha de siniestro");
      return;
    }
    if (formulario.fc_parentesco === "") {
      toastr.error("Debe Llenar El Patentezco");
      return;
    }
    if (formulario.fc_nombre_quien === "") {
      toastr.error("Debe Llenar El Nombre");
      return;
    }
    if (formulario.fc_telefono_reporta === "") {
      toastr.error("Debe Llenar El Teléfono");
      return;
    }
    if (formulario.fc_estimada === "") {
      toastr.error("Debe Llenar La cantidad estimada");
      return;
    }
    if (formulario.fc_calle === "") {
      toastr.error("Debe Llenar La Calle");
      return;
    }
    if (formulario.fc_colonia === "") {
      toastr.error("Debe Llenar La Colonia");
      return;
    }
    if (formulario.fc_cp === "") {
      toastr.error("Debe Llenar El CP");
      return;
    }
    if (formulario.fc_delegacion === "") {
      toastr.error("Debe Llenar La Delegación");
      return;
    }
    if (formulario.fc_ciudad === "") {
      toastr.error("Debe Llenar La Ciudad");
      return;
    }
    if (formulario.fc_email === "") {
      toastr.error("Debe Llenar El Correo");
      return;
    }
    if (formulario.fc_observaciones === "") {
      toastr.error("Debe Llenar Las Observaciones");
      return;
    }
    const resp: any = await siniestroAction({
      ...formulario,
      fi_tipo_siniestro: +formulario.fi_tipo_siniestro,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        } else {
          toastr.error(err.data.message);
        }
      });
    if (resp) {
      console.log(resp);
      verAction(seleccion);
      toastr.info(resp.message);
      limpiarFormulario();
    }
  };
  useEffect(() => {
    dispatch(seleccionarPagina("p-siniestros"));
  }, [0]);

  useEffect(() => {
    if (data) {
      if (data.validacion) {
        if (data.validacion.length > 0) {
          handleChangeAll({
            ...formulario,
            fc_calle: data.validacion[0].Calle,
            fc_num_int: data.validacion[0].Num_int,
            fc_num_ext: data.validacion[0].Num_ext,
            fc_colonia: data.validacion[0].Colonia,
            fc_delegacion: data.validacion[0].Delegacion,
            fc_cp: data.validacion[0].CP,
            fc_ciudad: data.validacion[0].Ciudad_Aseg,
            fc_estado: data.validacion[0].Estado_Aseg,
          });
        }
      }
    }
  }, [data]);
  if (!validacion) {
    return (
      <ValidacionComponent
        inactivo={false}
        validacion={validacion}
        setValidacion={setValidacion}
      />
    );
  }
  return (
    <>
      <div className="w-full">
        <h1 className="mb-10 rounded-t-xl border-b-2 border-primary py-2 pl-3 text-primary">
          Registrar Siniestro
        </h1>
      </div>
      <div className="w-full pb-5">
        <div className="mt-2 grid grid-cols-1 gap-6 px-2 sm:grid-cols-2 lg:grid-cols-3">
          <div className="px-3 py-1">
            <Label>Descripción:</Label>
            <textarea
              className="focus-visible:ring-ring flex h-12 w-full items-center justify-between rounded-xl border border-gray-light bg-gray-ultra-light px-3 py-2 text-base ring-primary-ultra-light file:border-0 file:bg-transparent file:text-sm placeholder:text-gray focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2  disabled:cursor-not-allowed disabled:opacity-50"
              onChange={handleTexareChange}
              value={formulario.fc_descripcion}
              name="fc_descripcion"
              id=""
              cols={40}
              rows={2}
            ></textarea>
          </div>
          <div className="px-3 py-1">
            <Label>Tipo Siniestro:</Label>
            <select
              className="focus-visible:ring-ring flex h-12 w-full items-center justify-between rounded border border-gray-light bg-gray-ultra-light px-3 py-2 text-sm ring-primary-ultra-light file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2  disabled:cursor-not-allowed disabled:opacity-50"
              name="fi_tipo_siniestro"
              onChange={handleSelectChange}
            >
              <option value="">Selecciona una opción</option>
              <option value="1">Accidente</option>
              <option value="2">Robo</option>
            </select>
          </div>
          <div className="px-3 py-1">
            <Label>Fecha de siniestro</Label>
            <Input
              type="date"
              name="fc_fecha_siniestro"
              value={formulario.fc_fecha_siniestro}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Parentesco Reporta:</Label>
            <select
              className="focus-visible:ring-ring flex h-12 w-full items-center justify-between rounded border border-gray-light bg-gray-ultra-light px-3 py-2 text-sm ring-primary-ultra-light file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2  disabled:cursor-not-allowed disabled:opacity-50"
              name="fc_parentesco"
              onChange={handleSelectChange}
            >
              <option value="">Selecciona una opción</option>
              <option value="Titular">Titular</option>
              <option value="Conyugue">Conyugue</option>
              <option value="Hijos">Hijos</option>
              <option value="Padres">Padres</option>
            </select>
          </div>
          <div className="px-3 py-1">
            <Label>Nombre de quien reporta:</Label>
            <Input
              type="text"
              name="fc_nombre_quien"
              value={formulario.fc_nombre_quien}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Teléfono de quien reporta:</Label>
            <Input
              type="text"
              name="fc_telefono_reporta"
              value={formulario.fc_telefono_reporta}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Cantidad Estimada:</Label>
            <Input
              type="text"
              name="fc_estimada"
              value={formulario.fc_estimada}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Calle:</Label>
            <Input
              type="text"
              name="fc_calle"
              value={formulario.fc_calle}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Num Int:</Label>
            <Input
              type="text"
              name="fc_num_int"
              value={formulario.fc_num_int}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Num Ext:</Label>
            <Input
              type="text"
              name="fc_num_ext"
              value={formulario.fc_num_ext}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Colonia:</Label>
            <Input
              type="text"
              name="fc_colonia"
              value={formulario.fc_colonia}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>C.P:</Label>
            <Input
              type="text"
              name="fc_cp"
              value={formulario.fc_cp}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Delegación:</Label>
            <Input
              type="text"
              name="fc_delegacion"
              value={formulario.fc_delegacion}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Ciudad:</Label>
            <Input
              type="text"
              name="fc_ciudad"
              value={formulario.fc_ciudad}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Estado:</Label>
            <Input
              type="text"
              name="fc_estado"
              value={formulario.fc_estado}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Email:</Label>
            <Input
              type="text"
              name="fc_email"
              value={formulario.fc_email}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Observaciones:</Label>
            <Input
              type="text"
              name="fc_observaciones"
              value={formulario.fc_observaciones}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Marca:</Label>
            <Input
              type="text"
              name="fc_marca"
              value={formulario.fc_marca}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1">
            <Label>Modelo:</Label>
            <Input
              type="text"
              name="fc_modelo"
              value={formulario.fc_modelo}
              onChange={handleInputChange}
            />
          </div>
          <div className="px-3 py-1 text-center">
            <Button className="mt-5" onClick={agregarSiniestro}>
              Generar siniestro
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
